import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import AppRouter from 'routes/router';

import { ChakraProvider } from '@chakra-ui/react';

import { ToastContainer } from 'shared/toast';
import customTheme from 'styles/theme/customTheme';

import 'react-perfect-scrollbar/dist/css/styles.css';

import 'styles/css/all.scss';

const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={customTheme}>
        <DndProvider backend={HTML5Backend}>
          <AppRouter />
        </DndProvider>
        <ToastContainer />
      </ChakraProvider>

      <ReactQueryDevtools position="bottom-right" />
    </QueryClientProvider>
  );
};

export default App;
